export default "__VITE_ASSET__jwP1S7x9__"